import { setRangeMin } from './helpers';

export const setRoomAreaMin = setRangeMin('room_area');
